import React, { Component } from "react";
import PropTypes from "prop-types";
import Radium from "radium";
import SuggestSelectInput from "../../../../Common/suggestSelectInput";
import Validator from "../../../../Common/validator";

class ListItem extends Component {
  constructor(props) {
    super(props);
    const { item } = this.props;
    let shower = item
    if(item !== null && item !== undefined && !item.name) {
      shower = {name : item }
    }
    this.state = {
      suggestionsValue: {
        name: shower && shower.name || '',
        id: shower && shower.id ||'',
      },
    };
  }
  onSuggestionChange = (val) => {
    this.props.onSubChange(val)
  };
  render() {
    const {
      getUsageSuggestions,
      suggestions,
      setUsageKindTouched,
      addEmptyUsage,
      isKindValid,
      index,
      placeholder,
      item,
      remove
    } = this.props;
    let shower = item
    if(item !== null && item !== undefined && item.name === undefined || item.name === null) {
      shower = {name :item }
    }
    if (!item) {
      shower = { name: ''}
    }
    return (
      <div className="row" style={styles.container}>
        <div style={{
            textAlign: "right"
        }} className="col-xs-2">
            {index}.
        </div>
        <div style={styles.firstColumn} className="col-xs-8">
          <Validator isValid={isKindValid}>
            <SuggestSelectInput
              onQuery={getUsageSuggestions}
              suggestions={suggestions}
              placeholder={placeholder}
              onChange={(val) => {
                this.onSuggestionChange(val);
              }}
              value={shower}
              inputStyle={styles.input}
              onBlur={setUsageKindTouched}
            />
          </Validator>
        </div>
        <div style={{
            textAlign: "right",
        }} 
        className="col-xs-2"
        onClick={() => {
          remove()
        }}
        >
              <i
              style={{
                paddingRight: 12
              }}
                    className={"fa fa-trash-o"}
                    aria-hidden="true"
                ></i>
        </div>
        </div>
    );
  }
}

var styles = {
  container: {
    marginLeft: "0",
    marginRight: "0",
    marginBottom: "8px",
    lineHeight: "35px",
  },
  firstColumn: {
    paddingLeft: "0",
  },
  unit: {
    textAlign: "right",
  },
  input: {
    "-webkit-appearance": "none",
    border: "none",
    display: "block",
  },
};
ListItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    unit: PropTypes.string,
    kindTouched: PropTypes.bool,
    amount: PropTypes.number.isRequired,
    amountTouched: PropTypes.bool,
  }),
  isKindValid: PropTypes.bool.isRequired,
  isAmountValid: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  type: PropTypes.oneOf(["materiel", "materiale"]),
  updateUsageAmount: PropTypes.func.isRequired,
  getUsageSuggestions: PropTypes.func.isRequired,
  suggestions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      unit: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  updateUsageKind: PropTypes.func.isRequired,
  setUsageAmountTouched: PropTypes.func.isRequired,
  setUsageKindTouched: PropTypes.func.isRequired,
  addEmptyUsage: PropTypes.func.isRequired,
};
export default Radium(ListItem);






// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/Usage/listitem2.jsx